import axios from '../../axios';

//加载头文件
//import * as StkInProductReturnApi from './moudules/stk/StkInProductReturnApi'; //产成品退货单
//  StkInProductReturnApi,//产成品退货单

// 产成品退货单列表
export const getStkInProductReturnPage = data => {
return axios({
url: '/api/sys/stk/getStkInProductReturnPage',
method: 'post',
data
})
};
// 产成品退货总合计
export const getStkInProductReturnSum = data => {
  return axios({
  url: '/api/sys/stk/getStkInProductReturnSum',
  method: 'post',
  data
  })
  };
// 产成品退货单保存
export const saveStkInProductReturn = data => {
return axios({
url: '/api/sys/stk/saveStkInProductReturn',
method: 'post',
data
})
};

// 产成品退货单修改
export const updateStkInProductReturn = data => {
return axios({
url: '/api/sys/stk/updateStkInProductReturn',
method: 'post',
data
})
};

// 产成品退货单删除
export const deleteStkInProductReturns = data => {
return axios({
url: '/api/sys/stk/deleteStkInProductReturns',
method: 'post',
data
})
};

// 产成品退货单查单条
export const getStkInProductReturn = data => {
return axios({
url: '/api/sys/stk/getStkInProductReturn',
method: 'post',
data
})
};


// 产成品退货单审核/反
export const auditStkInProductReturns = data => {
  return axios({
    url: '/api/sys/stk/auditStkInProductReturns',
    method: 'post',
    data
  })
};
// 产成品退货单作废
export const cancelStkInProductReturns = data => {
  return axios({
    url: '/api/sys/stk/cancelStkInProductReturns',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/stk/StkInProductReturnApi.js